import { render, staticRenderFns } from "./TaskTypeBlock.vue?vue&type=template&id=238fbc61&scoped=true"
import script from "./TaskTypeBlock.vue?vue&type=script&lang=ts"
export * from "./TaskTypeBlock.vue?vue&type=script&lang=ts"
import style0 from "./TaskTypeBlock.vue?vue&type=style&index=0&id=238fbc61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238fbc61",
  null
  
)

export default component.exports